import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.reduce.js";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = {
  class: "list-page-table-panel list-page-table-panel--fill overflow-y-auto"
};
const _hoisted_2 = {
  key: 0,
  class: "flex items-center justify-center py-12"
};
const _hoisted_3 = {
  key: 1,
  class: "space-y-4 p-1"
};
const _hoisted_4 = {
  class: "grid grid-cols-2 gap-4 md:grid-cols-3 xl:grid-cols-6"
};
const _hoisted_5 = {
  class: "bg-white rounded-xl border border-slate-200 p-4"
};
const _hoisted_6 = {
  class: "mt-1 text-2xl font-semibold text-slate-800"
};
const _hoisted_7 = {
  class: "bg-white rounded-xl border border-slate-200 p-4"
};
const _hoisted_8 = {
  class: "mt-1 text-2xl font-semibold text-slate-800"
};
const _hoisted_9 = {
  class: "bg-white rounded-xl border border-slate-200 p-4"
};
const _hoisted_10 = {
  class: "bg-white rounded-xl border border-slate-200 p-4"
};
const _hoisted_11 = {
  class: "mt-1 text-2xl font-semibold text-slate-800"
};
const _hoisted_12 = {
  class: "bg-white rounded-xl border border-slate-200 p-4"
};
const _hoisted_13 = {
  class: "mt-1 text-2xl font-semibold text-slate-800"
};
const _hoisted_14 = {
  class: "bg-white rounded-xl border border-slate-200 p-4"
};
const _hoisted_15 = {
  class: "grid grid-cols-1 gap-4 lg:grid-cols-2"
};
const _hoisted_16 = {
  class: "bg-white rounded-xl border border-slate-200 p-4"
};
const _hoisted_17 = {
  key: 0,
  class: "py-8 text-center text-sm text-slate-400"
};
const _hoisted_18 = {
  key: 1,
  class: "mt-3 w-full text-sm"
};
const _hoisted_19 = {
  class: "py-2 pr-2"
};
const _hoisted_20 = ["title"];
const _hoisted_21 = {
  class: "py-2 text-center text-slate-600"
};
const _hoisted_22 = {
  class: "py-2"
};
const _hoisted_23 = {
  class: "flex items-center gap-2"
};
const _hoisted_24 = {
  class: "h-1.5 flex-1 rounded-full bg-slate-100"
};
const _hoisted_25 = {
  class: "w-12 text-right text-xs text-slate-600"
};
const _hoisted_26 = {
  class: "bg-white rounded-xl border border-slate-200 p-4"
};
const _hoisted_27 = {
  key: 0,
  class: "py-8 text-center text-sm text-slate-400"
};
const _hoisted_28 = {
  key: 1,
  class: "mt-3 w-full text-sm"
};
const _hoisted_29 = {
  class: "py-2 text-slate-700"
};
const _hoisted_30 = {
  class: "py-2 text-center text-slate-600"
};
const _hoisted_31 = {
  class: "py-2 text-center"
};
const _hoisted_32 = {
  class: "bg-white rounded-xl border border-slate-200 p-4"
};
const _hoisted_33 = {
  key: 0,
  class: "py-8 text-center text-sm text-slate-400"
};
const _hoisted_34 = {
  key: 1,
  class: "mt-4 flex h-32 items-end gap-[2px]"
};
const _hoisted_35 = ["title"];
const _hoisted_36 = {
  key: 2,
  class: "mt-1 flex justify-between text-xs text-slate-400"
};
import { ref, computed, onMounted } from 'vue';
import { ElMessage } from 'element-plus';
import { meetingApi } from '@/api/meeting';
export default {
  __name: 'MeetingStatsPanel',
  setup(__props) {
    const loading = ref(false);
    const myStats = ref({});
    const managedStats = ref({});

    // managed 接口所有人都可调用，无管理会议时返回空数据，正常显示 0
    const managedMeetings = computed(() => managedStats.value?.meetings || []);
    const managedAssignees = computed(() => managedStats.value?.assignees || []);
    const dailyTrend = computed(() => myStats.value?.dailyTrend || []);

    // 完成率：后端返回 0~100 百分比（保留 1 位小数），直接取整展示
    const formatRate = rate => {
      const n = Number(rate);
      if (!Number.isFinite(n)) return '0%';
      return `${Math.round(n)}%`;
    };
    const ratePercent = rate => {
      const n = Number(rate);
      if (!Number.isFinite(n) || n <= 0) return '0%';
      return `${Math.min(100, Math.round(n))}%`;
    };

    // 柱高按当天最大值归一化（0 值也给 2px 底线，保持可悬停提示）
    const trendMax = computed(() => {
      return dailyTrend.value.reduce((max, d) => Math.max(max, Number(d.created) || 0, Number(d.done) || 0), 0);
    });
    const barHeight = value => {
      const n = Number(value) || 0;
      if (trendMax.value <= 0) return '2%';
      return `${Math.max(2, Math.round(n / trendMax.value * 100))}%`;
    };
    const fetchStats = async () => {
      loading.value = true;
      try {
        const [mine, managed] = await Promise.all([meetingApi.getMyActionStats(), meetingApi.getManagedMeetingStats()]);
        myStats.value = mine || {};
        managedStats.value = managed || {};
      } catch (error) {
        ElMessage.error('获取会议统计失败');
        console.error('获取会议统计失败:', error);
      } finally {
        loading.value = false;
      }
    };
    onMounted(fetchStats);
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [loading.value ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[0] || (_cache[0] = [_createElementVNode("svg", {
        class: "w-8 h-8 animate-spin text-primary-500",
        fill: "none",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("circle", {
        class: "opacity-25",
        cx: "12",
        cy: "12",
        r: "10",
        stroke: "currentColor",
        "stroke-width": "4"
      }), _createElementVNode("path", {
        class: "opacity-75",
        fill: "currentColor",
        d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      })], -1)]))])) : (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_cache[1] || (_cache[1] = _createElementVNode("p", {
        class: "text-xs text-slate-500"
      }, "我的待处理", -1)), _createElementVNode("p", _hoisted_6, _toDisplayString(myStats.value.pending || 0), 1)]), _createElementVNode("div", _hoisted_7, [_cache[2] || (_cache[2] = _createElementVNode("p", {
        class: "text-xs text-slate-500"
      }, "我的进行中", -1)), _createElementVNode("p", _hoisted_8, _toDisplayString(myStats.value.inProgress || 0), 1)]), _createElementVNode("div", _hoisted_9, [_cache[3] || (_cache[3] = _createElementVNode("p", {
        class: "text-xs text-slate-500"
      }, "我的逾期", -1)), _createElementVNode("p", {
        class: _normalizeClass(["mt-1 text-2xl font-semibold", (myStats.value.overdue || 0) > 0 ? 'text-red-600' : 'text-slate-800'])
      }, _toDisplayString(myStats.value.overdue || 0), 3)]), _createElementVNode("div", _hoisted_10, [_cache[4] || (_cache[4] = _createElementVNode("p", {
        class: "text-xs text-slate-500"
      }, "管理的会议数", -1)), _createElementVNode("p", _hoisted_11, _toDisplayString(managedStats.value.meetingCount || 0), 1)]), _createElementVNode("div", _hoisted_12, [_cache[5] || (_cache[5] = _createElementVNode("p", {
        class: "text-xs text-slate-500"
      }, "管理决策项完成率", -1)), _createElementVNode("p", _hoisted_13, _toDisplayString(formatRate(managedStats.value.doneRate)), 1)]), _createElementVNode("div", _hoisted_14, [_cache[6] || (_cache[6] = _createElementVNode("p", {
        class: "text-xs text-slate-500"
      }, "管理决策项逾期", -1)), _createElementVNode("p", {
        class: _normalizeClass(["mt-1 text-2xl font-semibold", (managedStats.value.overdueCount || 0) > 0 ? 'text-red-600' : 'text-slate-800'])
      }, _toDisplayString(managedStats.value.overdueCount || 0), 3)])]), _createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_cache[8] || (_cache[8] = _createElementVNode("h3", {
        class: "text-sm font-semibold text-slate-800"
      }, "按会议完成率", -1)), managedMeetings.value.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_17, " 暂无管理的会议 ")) : (_openBlock(), _createElementBlock("table", _hoisted_18, [_cache[7] || (_cache[7] = _createElementVNode("thead", null, [_createElementVNode("tr", {
        class: "text-left text-xs text-slate-500"
      }, [_createElementVNode("th", {
        class: "pb-2 font-medium"
      }, "会议主题"), _createElementVNode("th", {
        class: "pb-2 font-medium w-20 text-center"
      }, "完成/总数"), _createElementVNode("th", {
        class: "pb-2 font-medium w-40"
      }, "完成率")])], -1)), _createElementVNode("tbody", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(managedMeetings.value, m => {
        return _openBlock(), _createElementBlock("tr", {
          key: m.meetingId,
          class: "border-t border-slate-100"
        }, [_createElementVNode("td", _hoisted_19, [_createElementVNode("p", {
          class: "max-w-64 truncate text-slate-700",
          title: m.title
        }, _toDisplayString(m.title), 9, _hoisted_20)]), _createElementVNode("td", _hoisted_21, _toDisplayString(m.done || 0) + "/" + _toDisplayString(m.total || 0), 1), _createElementVNode("td", _hoisted_22, [_createElementVNode("div", _hoisted_23, [_createElementVNode("div", _hoisted_24, [_createElementVNode("div", {
          class: "h-1.5 rounded-full bg-primary-500",
          style: _normalizeStyle({
            width: ratePercent(m.doneRate)
          })
        }, null, 4)]), _createElementVNode("span", _hoisted_25, _toDisplayString(formatRate(m.doneRate)), 1)])])]);
      }), 128))])]))]), _createElementVNode("div", _hoisted_26, [_cache[10] || (_cache[10] = _createElementVNode("h3", {
        class: "text-sm font-semibold text-slate-800"
      }, "负责人排行", -1)), managedAssignees.value.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_27, " 暂无负责人数据 ")) : (_openBlock(), _createElementBlock("table", _hoisted_28, [_cache[9] || (_cache[9] = _createElementVNode("thead", null, [_createElementVNode("tr", {
        class: "text-left text-xs text-slate-500"
      }, [_createElementVNode("th", {
        class: "pb-2 font-medium"
      }, "负责人"), _createElementVNode("th", {
        class: "pb-2 font-medium w-24 text-center"
      }, "完成/总数"), _createElementVNode("th", {
        class: "pb-2 font-medium w-16 text-center"
      }, "逾期")])], -1)), _createElementVNode("tbody", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(managedAssignees.value, a => {
        return _openBlock(), _createElementBlock("tr", {
          key: a.userId,
          class: "border-t border-slate-100"
        }, [_createElementVNode("td", _hoisted_29, _toDisplayString(a.userName || `#${a.userId}`), 1), _createElementVNode("td", _hoisted_30, _toDisplayString(a.done || 0) + "/" + _toDisplayString(a.total || 0), 1), _createElementVNode("td", _hoisted_31, [_createElementVNode("span", {
          class: _normalizeClass((a.overdue || 0) > 0 ? 'font-medium text-red-600' : 'text-slate-600')
        }, _toDisplayString(a.overdue || 0), 3)])]);
      }), 128))])]))])]), _createElementVNode("div", _hoisted_32, [_cache[11] || (_cache[11] = _createStaticVNode("<div class=\"flex items-center justify-between\"><h3 class=\"text-sm font-semibold text-slate-800\">近 30 天决策项趋势</h3><div class=\"flex items-center gap-4 text-xs text-slate-500\"><span class=\"flex items-center gap-1\"><span class=\"inline-block h-2 w-2 rounded-sm bg-primary-400\"></span>新建 </span><span class=\"flex items-center gap-1\"><span class=\"inline-block h-2 w-2 rounded-sm bg-emerald-400\"></span>完成 </span></div></div>", 1)), dailyTrend.value.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_33, " 暂无趋势数据 ")) : (_openBlock(), _createElementBlock("div", _hoisted_34, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dailyTrend.value, d => {
        return _openBlock(), _createElementBlock("div", {
          key: d.date,
          class: "flex flex-1 items-end justify-center gap-[1px]",
          title: `${d.date} 新建 ${d.created || 0} / 完成 ${d.done || 0}`
        }, [_createElementVNode("div", {
          class: "w-1/2 rounded-t-sm bg-primary-400",
          style: _normalizeStyle({
            height: barHeight(d.created)
          })
        }, null, 4), _createElementVNode("div", {
          class: "w-1/2 rounded-t-sm bg-emerald-400",
          style: _normalizeStyle({
            height: barHeight(d.done)
          })
        }, null, 4)], 8, _hoisted_35);
      }), 128))])), dailyTrend.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_36, [_createElementVNode("span", null, _toDisplayString(dailyTrend.value[0].date), 1), _createElementVNode("span", null, _toDisplayString(dailyTrend.value[dailyTrend.value.length - 1].date), 1)])) : _createCommentVNode("", true)])]))]);
    };
  }
};